<sui-dialog-simple>
  <ng-template suiDialogHeader>
    <div class="dialog-header">
      <fa-icon [icon]="actionIcon"></fa-icon>
      <h2 ngpDialogTitle>{{ dialogTitle }}</h2>
    </div>

    <sui-button
      size="sm"
      variant="danger"
      [leadingIcon]="['fas', 'times']"
      [iconOnly]="true"
      ariaLabel="Close"
      (click)="cancel()"
    ></sui-button>
  </ng-template>

  <ng-template suiDialogContent>
    @if (formProperties.length > 0) {
      <app-dynamic-form
        [formProperties]="formProperties"
        [formGroup]="formGroup"
      ></app-dynamic-form>
    }
  </ng-template>

  <ng-template suiDialogFooter>
    <sui-button size="sm" variant="secondary" (click)="cancel()">
      {{ "btn.cancel" | translate }}
    </sui-button>
    <sui-button
      size="sm"
      variant="primary"
      [disabled]="!isValid()"
      (click)="save()"
    >
      {{ "btn.move" | translate }}
    </sui-button>
  </ng-template>
</sui-dialog-simple>
